import { render, staticRenderFns } from "./entryCourierInfo.vue?vue&type=template&id=724f47ae&scoped=true"
import script from "./entryCourierInfo.vue?vue&type=script&lang=js"
export * from "./entryCourierInfo.vue?vue&type=script&lang=js"
import style0 from "./entryCourierInfo.vue?vue&type=style&index=0&id=724f47ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f47ae",
  null
  
)

export default component.exports